import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="block group cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[3/4]'
      }`}>
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 牛牛影视高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
          {movie.rating}
        </span>

        {movie.hotRank && movie.hotRank <= 3 && (
          <span className="absolute top-2 right-2 bg-accent-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            TOP{movie.hotRank}
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-2">{movie.description}</p>
          <span className="inline-block mt-2 text-xs text-primary-300 font-medium whitespace-nowrap">
            立即观看 <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{movie.categoryLabel}</span>
          {movie.updateInfo && (
            <>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-secondary-600 truncate">{movie.updateInfo}</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}